<template>
  <div>
    <head-nav-bar title="确认下单" :fixed="true" />
    <div class="mt-header-nav confirm-box">
      <cell-box style="padding: 0.3rem 0;" :column="2">
        <cell-item
          label="联系人："
          :value="tableInfo.Contact ? tableInfo.Contact : tableInfo.NickName"
          style="gridColumn:span 2;"
        />
        <cell-item
          label="会员卡："
          v-if="tableInfo.MemberName"
          :value="tableInfo.MemberName"
          style="gridColumn:span 2;"
        />
        <cell-item label="桌台：" :value="tableInfo.TableName" />
        <cell-item label="就餐人数：" :value="tableInfo.PersonCount" />

        <cell-item label="电话：" :value="tableInfo.Phone" />
      </cell-box>
      <h3 class="selected-title">
        已选菜品
      </h3>
      <div class="select-foods detail-select-table">
        <template v-for="item in orderFoodList">
          <van-card :key="item.DishId" v-if="Number(item.Quantity) > 0">
            <template #price>
              <div style="color:#555">
                <van-tag
                  type="success"
                  round
                  v-if="tableInfo.IsMember && item.MemberUnitPrice != null"
                  >会</van-tag
                >
                &yen;{{
                  tableInfo.IsMember && item.MemberUnitPrice != null
                    ? item.MemberUnitPrice
                    : item.UnitPrice
                }}
                x {{ item.Quantity }}
              </div>
            </template>
            <template #title>
              <div class="food-title">
                <span>
                  {{ item.DishName }}/<em>{{ item.UnitName }}</em>
                  <span
                    v-if="item.PracticeDesc || item.CookingMethodDesc"
                    class="method-txt"
                  >
                    「做法」{{ item.PracticeDesc }}{{ item.CookingMethodDesc }}
                  </span>
                </span>
                <span v-if="item.IsPack">
                  <van-tag color="#f60" @click="openPack(item)"
                    >套餐&nbsp;<van-icon
                      :name="
                        openKeys.includes(item.DishId) ||
                        openKeys.includes(item.Id)
                          ? 'arrow-up'
                          : 'arrow-down'
                      "
                  /></van-tag>
                </span>
              </div>
            </template>
            <template #num>
              <span style="color:#f00"> &yen;{{ item.TotalPrice }}</span>
            </template>
            <template v-if="item.IsPack" #footer>
              <ul
                class="pack-detail"
                :class="{
                  'pack-detail-open':
                    openKeys.includes(item.DishId) ||
                    openKeys.includes(item.Id),
                }"
              >
                <li v-for="pack in item.PackDetails" :key="pack.Id">
                  {{ pack.Name }} x {{ pack.Quantity }}
                </li>
              </ul>
            </template>
          </van-card>
        </template>
      </div>
      <van-goods-action>
        <div slot="default" class="summary-info" style="width:60%">
          <span>
            <van-icon name="shopping-cart-o" />总数：<em
              >{{ total.Quantity }}
            </em></span
          >
          <span>
            <van-icon name="balance-o" />总计：<em
              >&yen; {{ total.TotalPrice }}</em
            >
          </span>
        </div>
        <van-goods-action-button
          type="danger"
          text="确认下单"
          @click="onSubmit"
        />
      </van-goods-action>
    </div>
  </div>
</template>

<script>
import "./rms.less";
import { accAdd } from "@/utils/common";
import { CellBox, CellItem } from "@/components/cell";
import restaurantApi from "@/api/restaurant.js";
import { mapState } from "vuex";
import {
  Cell,
  CellGroup,
  Button,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Card,
  Tag,
  Popup,
  Dialog,
  Icon,
} from "vant";
import { ls } from "@/utils/cache.js";
export default {
  name: "CreateOrder",
  components: {
    CellBox,
    CellItem,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Tag.name]: Tag,
    [Card.name]: Card,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
  },
  data() {
    return {
      orderFoodList: [],
      total: {
        Quantity: 0,
        TotalPrice: 0,
      },
      tableInfo: {},
      orderId: "",
      openKeys: [],
    };
  },
  computed: {
    ...mapState({
      wechatUserInfo: state => state.user.wechatUserInfo,
      restaruantInfo: state => state.user.restaruantInfo,
    }),
  },
  created() {
    this.orderFoodList = ls.get("order_data");
    this.tableInfo = ls.get("order_table_info");
    this.tableInfo = this.tableInfo ? this.tableInfo : {};
    this.orderId = this.$route.query.OrderId;
    this.init();
  },
  methods: {
    openPack(item) {
      let id = item.Id ? item.Id : item.DishId;
      if (this.openKeys.includes(id)) {
        this.openKeys = this.openKeys.filter(el => el != id);
      } else {
        this.openKeys.push(id);
      }
    },
    init() {
      let total = 0,
        num = 0;
      this.orderFoodList.forEach(item => {
        num = accAdd(num, item.Quantity);
        total = accAdd(total, item.TotalPrice);
      });

      this.total.Quantity = num;
      this.total.TotalPrice = total;
    },
    onSubmit() {
      const { restaruantInfo, tableInfo, wechatUserInfo } = this;
      const that = this;
      const Dishes = this.orderFoodList.map(p => {
        return {
          ...p,
          AccountItemId: p.DishId,
          AccountItemName: p.DishName,
          DiscountPrice: 0,
          FinalPrice: p.TotalPrice,
          UnitPrice:
            tableInfo.IsMember && p.MemberUnitPrice != null
              ? p.MemberUnitPrice
              : p.UnitPrice,
        };
      });
      if (this.orderId) {
        this.loading = true;
        const json = {
          OrderId: this.orderId,
          IsMobileOrder: true,
          IsPrint: true,
          Tables: [],
        };

        json.Tables = [
          {
            TableId: tableInfo.TableId,
            TableName: tableInfo.TableName,
            Dishes: Dishes,
          },
        ];
        //点菜
        restaurantApi
          .orderDish(json)
          .then(() => {
            Dialog({ message: "下单成功" }).then(() => {
              that.$router.push({
                name: "restaurantIndex",
                query: {
                  TableId: tableInfo.TableId,
                  CompanyId: restaruantInfo.CompanyId,
                },
              });
            });
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        //预订
        const param = {
          ...this.tableInfo,
          Dishes: Dishes,
          OpenId: wechatUserInfo.openid,
          IsConfirm: false,
        };
        restaurantApi.bookingOrder(param).then(() => {
          ls.remove("order_table_info");
          this.$router.push({
            name: "restaurantBookingList",
          });
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.detail-select-table {
  height: calc(100vh - 230px);
  padding-bottom: 0;
}
</style>
